import { v4 as uuidv4 } from "uuid";
import icon1 from "../../assets/img/icon/core-features/complete_engineering_manufacturing_solutions.png";
import icon2 from "../../assets/img/icon/core-features/strong_vendor_network.png";
import icon3 from "../../assets/img/icon/core-features/cost_reduction_support_1.png";
import icon4 from "../../assets/img/icon/core-features/quality_focused_approach_1.png";
import icon5 from "../../assets/img/icon/core-features/development_to_mass_production_support_1.png";
import icon6 from "../../assets/img/icon/core-features/multiple_manufacturing_processes_1.png";

const videoFeaturedData = [
  {
    id: uuidv4(),
    icon: icon1,
    heading: "Complete Engineering & Manufacturing Solutions",
    text: "Lorem ipsum dolor sit ame ctetur adipisic ing elit",
  },

  {
    id: uuidv4(),
    icon: icon2,
    heading: "Strong Vendor Network",
    text: "Lorem ipsum dolor sit ame ctetur adipisic ing elit",
  },

  {
    id: uuidv4(),
    icon: icon3,
    heading: "Cost Reduction Support",
    text: "Lorem ipsum dolor sit ame ctetur adipisic ing elit",
  },

  {
    id: uuidv4(),
    icon: icon4,
    heading: "Quality Focused Approach",
    text: "Lorem ipsum dolor sit ame ctetur adipisic ing elit",
  },
  
  {
    id: uuidv4(),
    icon: icon5,
    heading: "Development to Mass Production Support",
    text: "Lorem ipsum dolor sit ame ctetur adipisic ing elit",
  },

  {
    id: uuidv4(),
    icon: icon6,
    heading: "Multiple Manufacturing Processes",
    text: "Lorem ipsum dolor sit ame ctetur adipisic ing elit",
  },

  // {
  //   id: uuidv4(),
  //   icon: icon1,
  //   heading: "Technical + Commercial Support",
  //   text: "Lorem ipsum dolor sit ame ctetur adipisic ing elit",
  // },
];

export default videoFeaturedData;
